// extracted by mini-css-extract-plugin
module.exports = {"signUp":"withSignUp_signUp__b4NI5","loginForm":"withSignUp_loginForm__k05dg","logo":"withSignUp_logo__2BZwG"};